import api from "@/api/axios";
import { Promotion, Resident } from "@/constants/objects";

export const getSubscriptionPromotions = async () => {
  const response = await api.get("/getUserAvailableSubscriptionPromotions");
  const availablePromotions: Promotion[] = response.data.map((item: any) => {
    const isVoucher = !item.repeat;

    if (isVoucher) {
      return {
        id: item._id,
        name: item.title,
        buildings: item.buildings,
        type: "voucher" as const,
        isVoucher: true,
        amountUsed: item.amountUsed || 0,
        amountRemaining: item.amountRemaining || 0,
      };
    }

    return {
      id: item._id,
      name: item.title,
      buildings: item.buildings,
      type: "regular" as const,
      isVoucher: false,
    };
  });

  if (availablePromotions.length === 0) {
    throw new Error("No available promotions");
  }

  return availablePromotions;
};

export const getResidentsInBuildingsByPromotionLogicId = async (promotions: string[]) => {
  const response = await api.post("/getResidentsInBuildings", { promotionsIds: promotions });
  const residents: Resident[] = response.data.map((item: any) => ({
    id: item.id,
    email: item.email,
    buildingId: item.building,
    buildingTitle: item.buildingTitle,
    subscriptionPromotionLogicId: item.subscriptionPromotionLogicId,
    claimedPromotions: item.subscriptionInUse,
  }));
  return residents;
};

export const removeResident = async (resident: Resident) => {
  await api.post("/removeResident", {
    email: resident.email,
    subscriptionPromotionLogicId: resident.subscriptionPromotionLogicId,
  });
};
